import MuscleMassIcon from '../assets/icons/hugeicons_body-part-muscle.svg';
import BMIIcon from '../assets/icons/hugeicons_percent-circle.svg';
import BoneMassIcon from '../assets/icons/hugeicons_bone-01.svg';
import WeightIcon from '../assets/icons/hugeicons_weight-scale.svg';
import BodyFatIcon from '../assets/icons/hugeicons_percent-circle.svg';
import HeartPulseIcon from '../assets/icons/hugeicons_pulse-rectangle-01.svg';
import BloodPressureIcon from '../assets/icons/hugeicons_blood-pressure.svg';

// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_BASE_URL?.replace(/=+$/, '') || '',
  ENDPOINTS: {
    USER: '/mt-account/user',
    CURRENT_PATIENT: '/api/current_patient/',
    VITALS: '/vitals',
    CONSULTATION: '/consultation',
    QUESTIONNAIRE: '/mt-vmr/questionnaire',
    POD_IP: (ip) => `/mt-vmr/pod/ip/${ip}`,
    POD_CONSULTATION_EMAILS: '/mt-vmr/pod/consultation-emails',
    SUBMIT_QUESTIONNAIRE: '/mt-vmr/patientQuestionnaire/submit'
  }
};

// App Configuration
export const APP_CONFIG = {
  APP_NAME: 'Medical Pod',
  VERSION: '1.0.0',
  ROUTES: {
    DASHBOARD: '/',
    WELCOME: '/welcome',
    VITALS: '/vitals',
    CONSULTATION: '/consultation/2',
    ASSESSMENT: '/assessment',
    END_SESSION: '/end'
  }
};

// Mock Data
export const MOCK_DATA = {
  USER: {
    name: 'Guest',
    age: 30,
    gender: 'Male',
    patientId: '68'
  },
  VITALS: {
    standing: [
      { name: 'Muscle Mass', value: '74.5', unit: 'kg', icon: MuscleMassIcon },
      { name: 'Weight', value: '74.5', unit: 'kg', icon: WeightIcon },
      { name: 'Bone Mass', value: '74.5', unit: 'kg', icon: BoneMassIcon },
      { name: 'Heart pulse', value: '74.5', unit: 'bpm', icon: HeartPulseIcon },
      { name: 'Fat percentage', value: '74.5', unit: '%', icon: BodyFatIcon },
      { name: 'Blood pressure', value: '118 / 76', unit: 'mmHg', icon: BloodPressureIcon }
    ],
    sitting: [
      { name: 'BMI', value: '74.5', unit: '%', icon: '📊' },
      { name: 'Muscle Mass', value: '74.5', unit: '%', icon: '💪' },
      { name: 'Metabolic Age', value: '23', unit: 'years', icon: '⏰' },
      { name: 'Bone Mass', value: '74.5', unit: '%', icon: '🦴' },
      { name: 'Nerve Health', value: '74.5', unit: '%', icon: '🧠' },
      { name: 'Weight', value: '74.5', unit: 'kg', icon: '⚖️' },
      { name: 'Fat Ratio', value: '74.5', unit: '%', icon: '📈' },
      { name: 'Hydration', value: '74.5', unit: '%', icon: '💧' }
    ]
  },
  DOCTOR: {
    name: 'Dr. Mohammed Khaled',
    title: 'GP',
    avatar: '👨‍⚕️'
  }
};
